import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import 'bootstrap';
import {BrandService} from '../../services/brand.service';
import {Price} from '../../models/offer/price/price';

declare var $: any;
@Component({
  selector: 'app-data-act-modal',
  templateUrl: './data-act-modal.component.html',
})
export class DataActModalComponent implements OnInit {

  @Input() showModal = false;
  @Output() showModalChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
  ) {
  }

  ngOnInit() {}

  closeModal(e) {
    const target = $(e.target);
    if (target.hasClass('modal-data-act') || target.hasClass('icon-x')) {
      $('body').removeClass('form-modal-open');
      this.showModal = false;
      this.showModalChange.emit(this.showModal);
    }
  }
}
